export default {
    it: {
        "title": "I tuoi dati",
        "name": "Nome",
        "surname": "Cognome",
        "email": "Email",
        "pec": "Email",
        "telephone": "Telefono fisso",
        "mobile": "Cellulare",
        "job": "Occupazione",
        "piva": "Partita IVA",
        "codfisc": "Codice fiscale",
        "birthplace": "Luogo di nascita",
        "birthday": "Data di nascita",
        "telefon_mobile": "Recapito telefonico",
        "contact_times": "Fascia oraria di contatto",
        "telefon": "Telefono",
        "error_flux_code":  "Codice invio flusso trasmissioni",
        "elenco_registro": "Elenco/Registro",
        "document_type_1": "Tipo documento 1",
        "document_type_2": "Tipo documento 2",
        "persona": "Tipologia Utente",
        "browser": "Browser",
        "num_sessione": "Numero sessione",
        "data_sessione": "Data sessione"



    },
    en: {
        "title": "Your infos",
        "name": "Name",
        "surname": "Surname",
        "email": "Email",
        "pec": "Email",
        "telephone": "Telefono fisso",
        "mobile": "Mobile",
        "job": "Job",
        "piva": "VAT number",
        "codfisc": "Tax ID code",
        "birthplace": "Birthplace",
        "birthday": "Birthday",
        "telefon_mobile": "Phone number",
        "contact_times": "Contact time slot",
        "telefon": "Telephone",
        "error_flux_code": "Transmission Flow Code",
        "elenco_registro": "List/Register",
        "document_type_1": "Document Type 1",
        "document_type_2": "Document Type 2",
        "persona": "User Type",
        "browser": "Browser",
        "num_sessione": "Numero sessione",
        "data_sessione": "Data sessione"
    }
}